export const useToken = () => {
    return localStorage.getItem('token') || ''
}